import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { EmptyAnimationComponent } from "./empty-animation.component";
import { LottieComponent } from "ngx-lottie";

@NgModule({
  declarations: [EmptyAnimationComponent],
  imports: [
    CommonModule,
    TranslateModule,
    LottieComponent,
  ],
  exports: [EmptyAnimationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EmptyAnimationComponentModule {}
